import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchDeletePromisedData, getDropdownIdsFromSelectArray, getDropdownLabelsFromSelectArray } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { hardcodeDropdown } from "modules/paymentManagement/common/services";

export const getConfigs = async (filterObj) => {
    return await fetchAllPostPromisedData(endpoint?.cashManagement?.approvalConfig?.search, filterObj);
}

export const createConfig = async (form) => {
    let reqObj = createRefundConfigReqObj(form);
    return await fetchAllPostPromisedData(endpoint?.cashManagement?.approvalConfig?.create, reqObj);
}

export const updateConfig = async (form) => {
    let reqObj = createRefundConfigReqObj(form);
    return await fetchAllPostPromisedData(endpoint?.cashManagement?.approvalConfig?.update, reqObj, 'put');
}

export const getDropdownAsNumberArray = (items) =>
    items?.map((item) => Number(item?.value));

export const getFormattedPaymentConfig = (config, dropdownData) => {
    const { id, branchType, businessAreas, cashierOffices, paymentManagementApprovalConfigDtoList, createdOn, createdBy, updatedOn, updatedBy } = config;
    const { allActiveBu, allActiveRoles } = dropdownData;
    const updatedConfig = {
        id,
        updatedOn,
        updatedBy,
        branchType: dropdownData?.branchType?.find(el => el?.label == branchType),
        businessArea: businessAreas?.map(bu => allActiveBu?.find(el => el?.value === bu)),
        cashierOffices: cashierOffices?.map(c => allActiveBu?.find(el => el?.label == c)),
        approvalSettingDTO: paymentManagementApprovalConfigDtoList?.map((el, index) => {
            const { paymodeType, l1ApprovalRoles, l2ApprovalRoles, l3ApprovalRoles, l1Days, l2Days, l3Days } = el;
            return {
                id: index,
                paymodeType: hardcodeDropdown?.paymodeTypes?.find(el => el?.value === paymodeType),
                l1Roles: l1ApprovalRoles?.map(roleId => allActiveRoles?.find(el => el?.value == roleId)),
                l2Roles: l2ApprovalRoles?.map(roleId => allActiveRoles?.find(el => el?.value == roleId)),
                l3Roles: l3ApprovalRoles?.map(roleId => allActiveRoles?.find(el => el?.value == roleId)),
                l1Days,
                l2Days,
                l3Days
            }

        })
    }
    return updatedConfig;
}

export const getNumericIdsFromSelectArray = (items) =>
    items?.map((item) => Number(item?.value));

const getBranchTypeLabel = (branchType) => {
    if (Array.isArray(branchType)) {
        return branchType[0]?.label ?? "";
    }
    if (typeof branchType === "object" && branchType !== null) {
        return branchType.label ?? "";
    }
    return "";
};

const createRefundConfigReqObj = (form) => {
    const { businessArea = [], branchType, cashierOffices, approvalSettingDTO = [], isNew, id } = form;

    const branchTypeLabel = getBranchTypeLabel(branchType);
    let cashiers = branchTypeLabel.toLowerCase() === "advance" ? getDropdownLabelsFromSelectArray(cashierOffices)
        : businessArea?.map(bu => bu?.label);

    return {
        ...(!isNew && { id }),
        branchType: branchTypeLabel,
        businessAreas: getNumericIdsFromSelectArray(businessArea),
        cashierOffices: cashiers,
        paymentManagementApprovalConfigDtoList: approvalSettingDTO?.map(el => {
            const { paymodeType, l1Roles, l2Roles, l3Roles, l1Days, l2Days, l3Days } = el;
            return {
                paymodeType: paymodeType?.value,
                l1ApprovalRoles: getNumericIdsFromSelectArray(l1Roles),
                l2ApprovalRoles: getNumericIdsFromSelectArray(l2Roles),
                l3ApprovalRoles: getNumericIdsFromSelectArray(l3Roles),
                l1Days,
                l2Days,
                l3Days
            }
        })

    }
};

export const getFilterReqObj = (filters, allActiveBu) => {
    const { paymodeTypes = [], businessAreas = [], cashierOffices } = filters;
    let cashiers = [];

    if (cashierOffices || cashierOffices?.length > 0) {
        cashiers = Array.isArray(cashierOffices) ? getDropdownLabelsFromSelectArray(cashierOffices) : [cashierOffices?.label]
    }
    return {
        paymodeTypes: getDropdownIdsFromSelectArray(paymodeTypes),
        businessAreas: businessAreas?.length ? getDropdownIdsFromSelectArray(businessAreas) : [],
        cashierOffices: cashiers
    };
};

export const deleteConfig = async (id) => {
    let resp = await fetchDeletePromisedData(`${endpoint?.cashManagement?.approvalConfig?.delete}/${id}?type=paymentManagementApprovalConfig`)
    if (resp?.code === 200) {
        return true;
    } else {
        return false;
    }
}

export const PAYMENT_CONFIG_FILTER_FORM_FIELDS = {
    businessAreas: [],
    cashierOffice: [],
    paymodeTypes: []
}


export const newRow = {
    paymodeType: "",
    l1Roles: [],
    l2Roles: [],
    l3Roles: [],
    l1Days: "",
    l2Days: "",
    l3Days: ""
}
export const getProgressStepList = (approvalLevelCount = 0,resubmitHandler) => {
    const initialSteps = [{ title: "Request Created" },
    { title: "Sent for approval" },];
    const approvalSteps = Array.from({ length: approvalLevelCount }, (_, i) => ({ title: `L${i + 1} Approval`, actionNeededText:'Re-submit request', onEdit: resubmitHandler }));
    const finalStep = { title: 'Date extended' };

    return [...initialSteps, ...approvalSteps, finalStep];
};
